<div class="bg-th-yellow mt-0 container-fluid py-2">
  <div class="d-flex justify-content-between align-content-center">
    <i
      class="fa fa-arrow-left text-secondary my-auto pointer text-dark"
      [routerLink]="['/']"
    ></i>

    <a class="d-flex align-items-center text-secondary f18 my-auto text-dark">
      <span class="fw-bold"> درخواست‌های آب تانکر </span>
    </a>
  </div>
</div>

<main class="px-2">
  <!-- جدول اطلاعات -->
  <div class="border border-2 container-fluid row gx-0 gy-2 mt-3 p-2">
    <!-- جستجو -->

    <div class="col-12 p-1">
      <input
        type="text"
        class="w-100 form-control"
        placeholder="جستجو کنید ..."
        (input)="filterResult($event.target.value)"
      />
    </div>

    <!-- جدول اطلاعات -->
    <div class="section border border-2 mt-2">
      <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        <thead>
          <tr class="text-center">
            <!-- <th scope="col" class="">انتخاب</th> -->
            <th scope="col" class="">عملیات</th>
            <th scope="col" class="">تاریخ درخواست</th>
            <th scope="col" class="">تاریخ و ساعت مدنظر</th>
            <th scope="col" class="">مشتری</th>
            <th scope="col" class="">ثبت کننده</th>
            <th scope="col" class="">مقدار</th>
            <th scope="col" class="">توضیحات</th>
            <th scope="col" class="">وضعیت</th>
          </tr>
        </thead>

        <tbody>
          <tr class="f14 text-center" *ngFor="let item of lst_WaterRequests; let i = index">
            <td class="d-none">
              <input class="form-check-input" type="checkbox" (change)="setCheckBox($event.target.checked, item)"/>
            </td>

            <td class="">
              <i
                class="fa fa-check fa-lg text-success pointer mx-1"
                title="تایید"
                (click)="openApproveModal(item)"
              ></i>

              <i
                class="fa fa-times fa-lg text-danger pointer"
                title="رد"
                (click)="openRejectModal(item)"
              ></i>
            </td>

            <td>{{ item.strSaveDateTime | faNum }}</td>

            <td>{{ item.strRequestedDeliveryTime | faNum }}</td>

            <td>{{ item.strClientName }}</td>

            <td>{{ item.strFullName }}</td>

            <td>{{ item.iValue | faNum }}</td>

            <td>{{ item.strComment }}</td>

            <td>{{ item.strScheduleStatus ?? "-" }}</td>
          </tr>

          <tr *ngIf="!lst_WaterRequests || lst_WaterRequests.length === 0">
            <td colspan="9" class="text-center text-muted py-3">
              رکوردی برای نمایش وجود ندارد.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- تایید درخواست آب -->
  <div class="modal fade" id="approveWaterRequestModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title">تایید درخواست آب</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div
            [formGroup]="approveForm"
            class="container-fluid row gx-2 gy-2 p-2"
          >
            <!-- تاریخ تحویل -->
            <div class="position-relative col-12 col-md-6 p-2">
              <label class="mb-2 text-muted"> تاریخ تحویل </label>
              <ng-persian-datepicker
                [uiTheme]="'gray'"
                [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true"
                [dateFormat]="'jYYYY/jMM/jDD'"
              >
                <input
                  formControlName="strDelivery_Date"
                  class="form-control text-end"
                />
              </ng-persian-datepicker>
            </div>

            <!-- ساعت تحویل -->
            <div class="position-relative col-12 col-md-6 p-2">
              <label class="mb-2 text-muted"> ساعت تحویل </label>
              <div class="input-group clockpicker">
                <input
                  id="approveDeliveryTime"
                  readonly
                  class="form-control p-2 text-center"
                />
                <span class="input-group-addon">
                  <span class="glyphicon glyphicon-time"></span>
                </span>
              </div>
            </div>

            <!-- مقدار (لیتر) -->
            <div class="position-relative col-12 col-md-6 p-2">
              <label class="mb-2 text-muted"> مقدار (لیتر) </label>
              <input
                class="form-control p-2 text-center"
                formControlName="iValue"
                oninput="
                  this.value = this.value.replace(/[^0-9]/g, '').toString()
                "
              />
            </div>

            <!-- تانکر -->
            <div class="position-relative col-12 col-md-6 p-2">
              <label class="mb-2 text-muted"> تانکر (اختیاری) </label>
              <select class="form-select p-2" formControlName="strUnitID">
                <option class="text-center" value="">انتخاب نشده</option>
                <option
                  class="text-center"
                  *ngFor="let tanker of tankerList"
                  [value]="tanker.strUnitID"
                >
                  {{ tanker.strFullName }}
                </option>
              </select>
            </div>

            <!-- توضیحات -->
            <div class="position-relative col-12 p-2">
              <label class="mb-2 text-muted"> توضیحات </label>
              <textarea
                class="form-control"
                formControlName="strComment"
                style="height: 100px; resize: none"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-success" (click)="submitApprove()">
            تایید
          </button>
          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- رد درخواست آب -->
  <div class="modal fade" id="rejectWaterRequestModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title">رد درخواست آب</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div
            [formGroup]="rejectForm"
            class="container-fluid row gx-2 gy-2 p-2"
          >
            <!-- توضیحات -->
            <div class="position-relative col-12 p-2">
              <label class="mb-2 text-muted"> توضیحات </label>
              <textarea
                class="form-control"
                formControlName="strComment"
                style="height: 100px; resize: none"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-danger" (click)="submitReject()">رد</button>
          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
